import React from 'react';
import { GetRegion } from 'constants.js';
import { hideEpg } from 'containers/Player/actions/optionButtons/epgButton.actions';
import {
  getProfileLastTouchFavorited,
  setProfileLastTouchFavorited,
} from 'utils/Socialization';
import api from 'services/api/microfwk';
import { GetEpgVersion } from 'utils/getEpgParams';
import {
  ALERT_SET_MESSAGE,
  ALERT_SHOW,
} from '../../../Player/actions/alert/constants';
import {
  FETCH_FAVORITE_CHANNELS_INIT,
  FETCH_FAVORITE_CHANNELS_SUCCESS,
  FETCH_FAVORITE_CHANNELS_ERROR,
  TOGGLE_SHOW_FAVORITE_CHANNELS,
  ADD_CHANNEL_TO_FAVORITE,
  REMOVE_CHANNEL_FROM_FAVORITE,
} from './constants';
import { hideLiveOptionsMenu } from '../../../Player/actions/optionButtons/liveOptionsButton.actions';
import {useSelector} from 'react-redux'
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';
import { addFavContentService, deleteFavContentService } from 'api/services/user/favorites';

const transformFavoriteChannels = groups =>
  groups.map(group => ({ id: group.id }));

const getLastTouchEnabled = metadata => {
  if (!metadata?.lasttouch_favoritedlive_toggle) return;
  const lastTouchEnabled = JSON.parse(metadata.lasttouch_favoritedlive_toggle);

  // eslint-disable-next-line consistent-return
  return lastTouchEnabled[GetRegion()] || lastTouchEnabled?.default;
};


export const getFavoriteChannels = () => async (dispatch, getState) => {
  dispatch({ type: FETCH_FAVORITE_CHANNELS_INIT });

  const { user: { userhash = '' } = {}, metadata } = getState();

  try {
    const epg_version = GetEpgVersion();
    const paramsFavoritedLive = {
      live: true,
      user_hash: userhash,
      epg_version,
    };

    const lastTouch = getProfileLastTouchFavorited();
    const lastTouchEnabled = getLastTouchEnabled(metadata);

    if (lastTouch && lastTouchEnabled?.enable) {
      paramsFavoritedLive.lasttouch = lastTouch;
    }

    const response = await api.get('services/user/favorited', {
      params: { ...paramsFavoritedLive },
    });

    const { response: { groups = [] } = {} } = response.data;
    const transformedFavoriteChannels = transformFavoriteChannels(groups);

    dispatch({
      type: FETCH_FAVORITE_CHANNELS_SUCCESS,
      data: transformedFavoriteChannels,
    });
  } catch (error) {
    let errorData;

    if (error.response) errorData = error.response.data;
    else if (error.request) errorData = error.request;
    else errorData = error.message;

    dispatch({
      type: FETCH_FAVORITE_CHANNELS_ERROR,
      error: errorData,
    });

    console.error(errorData);
  }
};

export const toggleShowFavoriteChannels = isActive => dispatch => {
  dispatch({
    type: TOGGLE_SHOW_FAVORITE_CHANNELS,
    payload: isActive,
  });
};

export const addChannelToFavorite = ({ id, group_id }) => async (
  dispatch,
  getState,
) => {
  dispatch({
    type: ADD_CHANNEL_TO_FAVORITE,
    data: id,
  });

  const state = getState();
  const claroLiteConfig = getClaroAdsKey(state);
  const {
    user: { userhash = '', region = '' } = {},
    metadata: { translations = '' } = {},
    asset = {},
  } = state;
  const labels = JSON.parse(translations).language[region];
  const params = {
    object_type: 1,
    object_id: group_id,
    user_hash: userhash,
    claroLiteConfig
  };

  try {
    const response = await addFavContentService(params);

    if (response.data.status !== '0') throw response.data;

    if (response?.data?.lasttouch?.favorited) {
      setProfileLastTouchFavorited(response.data.lasttouch.favorited);
    }
    dispatch(getFavoriteChannels());
    dispatch(hideLiveOptionsMenu());
    dispatch(hideEpg());
    dispatch({
      type: ALERT_SET_MESSAGE,
      payload: (
        <>
          <img
            style={{
              marginRight: '.3em',
              width: '1.2em',
            }}
            src={asset.playingLive_alert_channelFavorite_icon}
            alt="favorite icon"
          />
          <span>{labels.addFavorites_alert_title_label}</span>
          <span>{labels.addFavorites_alert_separatorPipe_format}</span>
          <span>{labels.addFavorites_alert_description_label}</span>
        </>
      ),
    });
    dispatch({
      type: ALERT_SHOW,
      payload: true,
    });
  } catch (error) {
    let errorData;

    if (error.response) errorData = error.response.data;
    else if (error.request) errorData = error.request;
    else if (error.errors) errorData = error.errors;
    else errorData = error.message;

    dispatch({
      type: REMOVE_CHANNEL_FROM_FAVORITE,
      data: id,
    });

    console.error(errorData);
  }
};

export const removeChannelsFromFavorite = ({ id, group_id }) => async (
  dispatch,
  getState,
) => {
  const state = getState();
  const claroLiteConfig = getClaroAdsKey(state);
  const {
    user: { userhash = '', region = '' } = {},
    metadata: { translations = '' } = {},
    asset = {},
  } = state;
  const labels = JSON.parse(translations).language[region];
  const params = {
    object_type: 1,
    object_id: group_id,
    user_hash: userhash,
    claroLiteConfig
  };

  try {
    const response = await deleteFavContentService(params);

    if (response.data.status !== '0') throw response.data;

    if (response?.data?.lasttouch?.favorited) {
      setProfileLastTouchFavorited(response.data.lasttouch.favorited);
    }
    dispatch({
      type: REMOVE_CHANNEL_FROM_FAVORITE,
      data: id,
    });
    dispatch(getFavoriteChannels());

    dispatch(hideLiveOptionsMenu());
    dispatch(hideEpg());
    dispatch({
      type: ALERT_SET_MESSAGE,
      payload: (
        <>
          <img
            style={{
              marginRight: '.3em',
              width: '1.2em',
            }}
            src={asset.playingLive_alert_channelFavorite_icon}
            alt="favorite icon"
          />
          <span>{labels.deleteFavorite_alert_title_label}</span>
          <span>{labels.addFavorites_alert_separatorPipe_format}</span>
          <span>{labels.deleteFavorite_alert_description_label}</span>
        </>
      ),
    });
    dispatch({
      type: ALERT_SHOW,
      payload: true,
    });
  } catch (error) {
    let errorData;

    if (error.response) errorData = error.response.data;
    else if (error.request) errorData = error.request;
    else if (error.errors) errorData = error.errors;
    else errorData = error.message;

    console.error(errorData);
  }
};
